import {FormControl, FormField} from 'platform/components';
import {Box, HStack, Space} from 'platform/foundation';

import {useWatch} from 'react-hook-form';

import {GetSalePresetSettingsV2ResponseBody, useGetQualitySealsQuery} from '@dms/api/sales';
import {buildQualitySealOptions} from '@dms/features/vehicle-forms-kit';
import i18n from '@dms/i18n';

import {SalePresetFormValues} from '../types/SalePresetFormValues';

interface QualitySealFormFieldProps {
  control: FormControl<SalePresetFormValues>;
  settings?: GetSalePresetSettingsV2ResponseBody;
}

export function QualitySealFormField(props: QualitySealFormFieldProps) {
  const makes = useWatch({control: props.control, name: 'makes'}) ?? [];
  const qualitySealKey = useWatch({
    control: props.control,
    name: 'defaultQualitySealKey',
  });
  const {currentData, isFetching, error} = useGetQualitySealsQuery({makeKeys: makes});
  const selectedQualitySeal =
    props.settings?.defaultQualitySeal?.key === qualitySealKey
      ? props.settings.defaultQualitySeal
      : null;

  return (
    <HStack spacing={6}>
      <Box flex={0.5}>
        <FormField
          control={props.control}
          type="choice"
          name="defaultQualitySealKey"
          options={buildQualitySealOptions({
            activeSeals: currentData ?? [],
            selectedSeal: selectedQualitySeal,
          })}
          isLoading={isFetching}
          isDisabled={isFetching || error !== undefined}
          label={i18n.t('entity.qualitySeal.labels.qualitySeal')}
        />
      </Box>
      <Space />
    </HStack>
  );
}
